export function formatCurrency(amount: number | string): string {
  try {
    // Convert to number if input is a string
    const parsedAmount: number = typeof amount === 'string' ? parseInt(amount, 10) : amount;

    // Check if the conversion is successful
    if (isNaN(parsedAmount)) {
      throw new Error('Invalid input. Please provide a valid amount in dollars.');
    }

    // Format as accounting value without decimals
    const formattedAmount: string = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(parsedAmount);

    return formattedAmount;
  } catch (error: any) {
    return error?.message;
  }
}
